var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card avoid-page-break",class:{
    'border-light-grey shadow fade-in': _vm.onScreen,
    'border-grey': !_vm.onScreen
  }},[_c('h4',{staticClass:"card-header text-center py-1",class:{
      'text-light has-background-sapn': _vm.onScreen,
      'border-bottom-grey': !_vm.onScreen
    }},[_vm._v(" Scan to display on another device ")]),_c('div',{staticClass:"card-body border-grey m-2 p-0 text-center",class:{
      'rounded shadow-sm': _vm.onScreen
    }},[_c('div',{staticClass:"mt-1"},[_c('img',{attrs:{"src":_vm.qrCode}})]),_c('h6',[_vm._v("QR Code")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }